import React from 'react';
import { FaRegCheckCircle, FaRegCircle } from 'react-icons/fa';
import { useSelector, useDispatch } from 'react-redux';
import { toggleEditMode, updateTodo } from '../actions/todosActions';
import UpdateForm from './UpdateForm';
import Tags from './Tags';

const Todo = props => {
  const dispatch = useDispatch();
  const {
    onToggleStatus, onRemoveCard, index,
  } = props;
  const todos = useSelector(state => state.todoApp);
  const {
    title, description, status, hidden, editMode, id, tags,
  } = todos[index];

  const onHandleToggle = () => {
    onToggleStatus(id);
  };
  const onHandleRemove = e => {
    e.stopPropagation();
    onRemoveCard(id);
  };
  const handleEditCard = e => {
    e.stopPropagation();
    dispatch(toggleEditMode(todos.findIndex(todo => todo.id === id)));
  };
  const handleUpdateCard = e => {
    const copyArray = [...todos];
    e.stopPropagation();
    e.preventDefault();
    const newTags = (e.target.tags.value) ? e.target.tags.value.split(',').map(i => i.trim()) : [];
    const updatedTodo = {
      ...copyArray[index],
      title: e.target.title.value,
      description: e.target.description.value,
      tags: newTags,
      editMode: false,
    };
    dispatch(updateTodo(updatedTodo, index));
  };

  return hidden ? ''
    : (
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      <div className={`Todo__card--${status}`} onClick={onHandleToggle} onKeyDown={onHandleToggle}>
        <FaRegCheckCircle className={`card__iconCheck--${status}`} />
        <FaRegCircle className={`card__iconCircle--${status}`} />
        <div className="card__text">
          <h3 className='card__title'>{title}</h3>
          <p>{description}</p>
          <Tags tags={tags} />
          {editMode ? '' : <button type="button" onClick={handleEditCard} className="card__button--edit">Edit</button>}
          {(editMode)
            ? (
              <UpdateForm
                handleUpdateCard={handleUpdateCard}
                index={index}
                handleEditCard={handleEditCard} />
            )
            : ''}
        </div>
        <button type="button" onClick={onHandleRemove} className={`card__button--${status}`}>Remove</button>
      </div>
    );
};

export default Todo;
